import { useMatomo } from "@jonkoops/matomo-tracker-react";
import Button from "../../components/Button";

function Quote() {
    const { trackEvent } = useMatomo();

    const onButtonClick = () => { 
        trackEvent({ category: 'our story', action: `button clicked` });
    }

    return (
        <div className="max-lg:px-5">
            <div className="bg-blue-50 w-full max-w-screen-md h-fit box mx-auto rounded-3xl p-8 my-32" id="story">
                <h1 className="text-2xl font-semibold text-blue-900 mb-6 max-md:text-2xl max-md:mb-4">
                    “Our crypto fund tracker and manager tool is the answer<br/>to keep up with the needs of professional investors to track and manage investments in Crypto, Web3 and Defi secure and sustainable.“
                </h1>
                <Button text="Our story" color="primary" size="medium" className="my-3" onClick={onButtonClick}/>
                <div className="mt-6">
                    <img src="/DEMO/images/michael.png" alt="CEO" className="w-[75px] h-[75px] box m-auto border-[5px] border-blue-100 rounded-full"/>
                    <p>
                        <span className="font-medium text-blue-900">
                            Michael Schöngruber
                        </span>
                        <br className="dont_ignore"/>
                        <span className="text-sm text-slate-400">
                            Founder and CEO of 3Folio
                        </span>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Quote;